import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetDescriptionsResponseTO } from 'models/Descriptions';
import API from 'services/API';

export const DESCRIPTIONS_BASE_QUERY_KEY = 'descriptions';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetDescriptionsResponseTO['propertyDescriptions']>,
  'queryKey' | 'queryFn'
>;

type UseFetchDescriptionsArgs = {
  propertyUid: string;
  isHotel?: boolean;
} & ReactQueryOptions;

const useFetchDescriptions = ({
  propertyUid,
  enabled = true,
  isHotel,
  ...options
}: UseFetchDescriptionsArgs) => {
  return useAppQuery({
    // @ts-expect-error TS2769 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    queryKey: [DESCRIPTIONS_BASE_QUERY_KEY, 'list', propertyUid],
    queryFn: async () => {
      const response = await API.get<GetDescriptionsResponseTO>(
        '/api/internal/property-descriptions',
        {
          params: isHotel ? { hotelUid: propertyUid } : { propertyUid },
        },
      );

      return response.data.propertyDescriptions;
    },
    enabled: enabled && !!propertyUid,
    staleTime: 30000,
    ...(options ?? {}),
  });
};

export default useFetchDescriptions;
